<template>
  <main role="main" class="col content-spacing">
    <div
      class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom border-bottom"
    >
      <h1 class="h2" v-if="viewData.account && viewData.account.parentAccount">
        Comissões
        <a
          :href="
            `/#/user/edit/${viewData.account.parentAccount.user.id}/${viewData.account.parentAccount.profile}`
          "
          >{{ viewData.account.parentAccount.user.name }}</a
        >
        por {{ viewData.account.user.name }}
      </h1>
      <div class="btn-toolbar mb-2 mb-md-0">
        <div
          class="btn-toolbar mb-2 mb-md-0"
          v-if="viewData.account && viewData.account.parentAccount"
        >
          <div class="btn-group mr-2">
            <BaseButtonComponent
              @click="$bvModal.show('bv-modal-example')"
              variant="secondary-action"
              >Nova Comissão</BaseButtonComponent
            >
          </div>

          <b-modal id="bv-modal-example" size="lg">
            <template v-slot:modal-title>Nova Comissão</template>

            <b-form>
              <error-container v-bind:errors="viewData.errors || []" />

              <b-form-group
                id="input-group-1"
                label="Data inicial"
                label-for="input-1"
              >
                <b-form-datepicker
                  :state="isOk('start')"
                  placeholder="Selecione uma data"
                  v-model="state.start"
                  class="mb-2"
                ></b-form-datepicker>
                <b-form-invalid-feedback>{{
                  getError('start')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Data final"
                label-for="input-1"
              >
                <b-form-datepicker
                  :state="isOk('end')"
                  placeholder="Selecione uma data"
                  v-model="state.end"
                  class="mb-2"
                ></b-form-datepicker>
                <b-form-invalid-feedback>{{
                  getError('end')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Valor"
                label-for="input-1"
              >
                <b-form-input
                  v-model="state.value"
                  placeholder="Informe o valor da comissão"
                  :state="isOk('value')"
                  @keypress="isNumber($event)"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('value')
                }}</b-form-invalid-feedback>
              </b-form-group>
            </b-form>

            <template
              v-slot:modal-footer
              style="display: block; justify-content: flex-start"
            >
              <BaseButtonComponent
                style="float: left"
                @click="$bvModal.hide('bv-modal-example')"
                variant="danger"
                >Fechar</BaseButtonComponent
              >

              <BaseButtonComponent
                style="float: right"
                @click="save"
                variant="primary-action"
                :disabled="viewData.start || !state.value"
              >
                <b-icon
                  v-if="viewData.saving"
                  icon="three-dots"
                  animation="cylon"
                ></b-icon>
                <span v-else>Adicionar comissão</span>
              </BaseButtonComponent>
            </template>
          </b-modal>
        </div>
      </div>
    </div>

    <b-row v-if="this.viewData.account">
      <b-col>
        <b-breadcrumb
          :items="[
            {
              text:
                'Lista de ' +
                this.getProfileName(this.viewData.account.profile),
              href: '/#/' + this.viewData.account.profile + 's',
            },
            {
              text: 'Comissões',
              href: '#',
              active: true,
            },
          ]"
        ></b-breadcrumb>
      </b-col>
    </b-row>

    <loading-list v-if="viewData.loading"></loading-list>

    <div
      class="d-flex justify-content-between flex-column h-100"
      v-else-if="!viewData.loading && state.list && state.list.length > 0"
    >
      <v-table>
        <thead>
          <tr>
            <td>Início</td>
            <td>Fim</td>
            <td>Valor</td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in state.list" :key="item.id">
            <td>{{ formatDate(item.start) }}</td>
            <td>{{ item.end ? formatDate(item.end) : '' }}</td>
            <td>{{ item.value ? item.value : 0 }} %</td>
            <td style="text-align: right">
              <BaseButtonComponent
                @click="() => remove(item)"
                size="sm"
                v-b-tooltip.hover
                title="Excluir"
                variant="danger"
              >
                <b-icon icon="trash" aria-hidden="true"></b-icon>
              </BaseButtonComponent>
            </td>
          </tr>
        </tbody>
      </v-table>
      <b-pagination-nav
        :link-gen="linkGen"
        :number-of-pages="state.pageCount"
        use-router
      ></b-pagination-nav>
    </div>
    <empty-list
      v-else-if="
        !viewData.loading && viewData.account && viewData.account.parentAccount
      "
    ></empty-list>
    <empty-list
      v-else-if="
        !viewData.loading && viewData.account && !viewData.account.parentAccount
      "
      message="Esse consumidor não foi indicado por um parceiro ou comercializador."
    ></empty-list>
  </main>
</template>

<script>
import helpers from '../../vue/helpers';
import { Api } from '../../vue/api';
import moment from 'moment-timezone';
import { BaseButtonComponent } from '../../ui/buttons';

const API = new Api();

export default {
  name: 'sales-comissions-index',
  data: function() {
    return {
      state: {
        list: [],
        start: '',
        end: '',
        value: 0,
      },
      viewData: {
        loading: true,
        saving: false,
        errors: [],
        states: [],
        userId: 0,
        accountId: 0,
        user: null,
      },
    };
  },
  computed: {},
  beforeMount: async function() {
    moment.locale('pt-BR');

    try {
      const result = await API.post('/execute', {
        path: '/account/' + this.$route.params.accountId,
        method: 'get',
      });

      this.viewData.account = result.model;
    } catch (ex) {
      this.$toast.error(helpers.getFirstError(ex));
      return;
    }

    await this.getAll();
  },
  methods: {
    getProfileName(profile) {
      if (profile && profile === 'consumer') {
        return 'Consumidores';
      } else if (profile && profile === 'trader') {
        return 'Comercializadores';
      } else if (profile && profile === 'partner') {
        return 'Parceiros';
      } else {
        return 'Usuários';
      }
    },
    formatDate(date) {
      return moment(date).format('L');
    },
    async save() {
      this.viewData.saving = true;

      try {
        const result = await API.post('/execute', {
          path: `/account/${this.viewData.account.id}/sales-comission`,
          method: 'post',
          data: {
            start: this.state.start,
            end: this.state.end,
            value: this.state.value,
          },
        });

        this.$bvModal.hide('bv-modal-example');
        await this.getAll();
      } catch (ex) {
        this.viewData.errors = helpers.getErrors(ex);
      }

      this.viewData.saving = false;
    },
    async getAll() {
      try {
        const result = await API.post('/execute', {
          path: `/account/${this.viewData.account.id}/sales-comissions`,
          method: 'get',
        });

        this.state.list = result.model;
        this.viewData.loading = false;
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    },
    async remove(item) {
      const ok = await this.$bvModal.msgBoxConfirm(
        'Deseja mesmo excluir essa comissão ?',
        {
          title: 'Confirmar Exclusão',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Sim',
          cancelTitle: 'Não',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        },
      );

      if (!ok) {
        return;
      }

      try {
        this.viewData.loading = true;

        const result = await API.post('/execute', {
          path:
            '/account/' +
            this.viewData.account.id +
            '/sales-comission/' +
            item.id,
          method: 'delete',
        });

        await this.getAll();
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    },
    linkGen(pageNum) {
      return pageNum === 1 ? '?' : `?page=${pageNum}`;
    },
    getError(property) {
      return helpers.getError(this.viewData.errors, property);
    },
    isOk(property) {
      let hasError = helpers.hasError(this.viewData.errors, property);
      if (hasError) {
        return false;
      }
    },
    isNumber($event) {
      return helpers.isNumber($event);
    },
  },
  components: {
    BaseButtonComponent,
  },
};
</script>
